import { detectIncognito } from "detectincognitojs";
import { storageUtil } from "@utils/storageUtil";

const STORAGE_KEY = "isPrivateMode";
let memoryCache: boolean | null = null;

/**
 * Safely detects incognito/private mode.
 * Returns a boolean and caches result for 1 day.
 * Uses memory cache + localStorage TTL from storageUtils.
 */
export async function detectIncognitoTab(): Promise<boolean> {
  // Memory cache first
  if (memoryCache !== null) return memoryCache;

  // Check cached value
  const cached = storageUtil.get<boolean>(STORAGE_KEY);
  if (cached !== null) {
    memoryCache = cached;
    return cached;
  }

  try {
    const result = await detectIncognito();
    const isPrivate = !!result.isPrivate;

    memoryCache = isPrivate;

    // Cache only on successful detection
    storageUtil.set(STORAGE_KEY, isPrivate);

    return isPrivate;
  } catch (error) {
    console.error("Incognito detection failed:", error);

    // Fallback to true without caching
    memoryCache = true;
    return true;
  }
}
